import { IReduxStore } from "Redux/Store/IReduxStore";

export const getSpotList = (state: IReduxStore, id: number|string) => state.spotList.spotList.entries[id];
